import { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
}));

const BasicStatRow = (props) => {
  const classes = useStyles();
  const [rowData, setRowData] = useState(props.data);

  useEffect(() => {
    setRowData(props.data);
  }, [props.data]);

  return (
    <div className={classes.root}>
      <div>11</div>
      <div>11</div>
      <div>11</div>
      <div>11</div>
      <div>11</div>
      <div>11</div>
    </div>
  );
};

export default BasicStatRow;
